import React, { useContext, useState } from 'react';
import { MenuItem, ListItemIcon, ListItemText, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormInput from '../../../SystemDesign/FormInput';
import { useUpdateRaterTypeMutation } from '../../../services/SkillsManagement';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import { useDispatch } from 'react-redux';
import { UPDATE_RATER_TYPE } from '../../../Reducers/Actions';

// Update Rater Type dialog, modeled after Roles/UpdateRole.jsx
const UpdateRaterType = ({ row }) => {
  const [updateRaterType] = useUpdateRaterTypeMutation();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
  const [close, setClose] = useState(false);
  const dispatch = useDispatch();

  const initialValues = {
    name: row?.original?.name || '',
    description: row?.original?.description || ''
  };

  const [formValues, setFormValues] = useState(initialValues);

  const formFields = [
    { type: 'text', name: 'name', label: 'Name', required: true },
    { type: 'text', name: 'description', label: 'Description', required: false }
  ];

  const formValidationSchema = yup.object().shape({
    name: yup
      .string()
      .required('Name is required')
      .min(2, 'Name must be at least 2 characters'),
    description: yup.string().nullable()
  });

  const handleSubmit = async (values, actions) => {
    try {
      const response = await updateRaterType({
        id: String(row.original.id),
        body: {
          name: values.name,
          // Allow null description when empty
          ...(values.description ? { description: values.description } : { description: null })
        }
      }).unwrap();

      if (response?.raterType) {
        dispatch({ type: UPDATE_RATER_TYPE, payload: response.raterType });
      }

      setInfoAlert({ severity: 'success', message: `Rater type ${values.name} updated successfully` });
      setOpenSnackBar(true);
      setClose(true);
    } catch (error) {
      setInfoAlert({ severity: 'error', message: error?.data?.message || 'An error occurred while updating the rater type' });
      setOpenSnackBar(true);
    }
    actions.setSubmitting(false);
  };

  return (
    <MuiDialog
      icon={<EditIcon />}
      triggerButton={
        <MenuItem>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Update</ListItemText>
        </MenuItem>
      }
      title="Update Rater Type"
      subtitle={`Update rater type ${row?.original?.name || ''}`}
      content={
        <Formik
          initialValues={formValues}
          validationSchema={formValidationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form id="updateRaterTypeForm">
              <Grid container spacing={2} marginTop={2}>
                {formFields.map((field, index) => (
                  <Grid item size={{ xs: 12 }} key={index}>
                    <FormInput
                      type={field.type}
                      name={field.name}
                      label={field.label}
                      required={field.required}
                      value={formik.values[field.name]}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setFormValues({ ...formValues, [field.name]: e.target.value });
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Form>
          )}
        </Formik>
      }
      existAction={true}
      actionTitle="Update"
      actionType="submit"
      formId="updateRaterTypeForm"
      onClose={close}
    />
  );
};

export default UpdateRaterType;
